export const environment = {
    production: false,
    api: {
        endpoint: 'https://api-staging.pernod-ricard.io/v2/ocb',
        scope: 'api://140936aa-8810-402f-92a3-b9a607dec45c/user_impersonation'
    },
    azure: {
        ad: {
            instance: 'https://login.microsoftonline.com/',
            clientId: '435c3f8f-7d19-48f0-9059-89513774893c',
            tenantId: '933c9cbe-35d3-4416-abbd-ddd1bca5879c'
        }
    }
};
